(() => {
  'use strict';
  let pendingForm = null;
  let pendingMode = 'cart';
  let priorFocus = null;

  function dialogFor(form) {
    const widget = form?.closest('product-form[data-grifone-preorder="true"]');
    return widget?.parentElement.querySelector('[data-grifo-dialog]') || null;
  }
  function close(dialog) {
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('grifo-preorder-open');
    const checkbox = dialog.querySelector('[data-grifo-checkbox]');
    const confirm = dialog.querySelector('[data-grifo-confirm]');
    if (checkbox) checkbox.checked = false;
    if (confirm) { confirm.disabled = true; confirm.textContent = 'Confermo'; }
    dialog.querySelector('[data-grifo-error]')?.remove();
    pendingForm = null;
    pendingMode = 'cart';
    if (priorFocus?.isConnected) priorFocus.focus();
  }
  function open(form, mode) {
    const dialog = dialogFor(form);
    if (!dialog) return false;
    pendingForm = form;
    pendingMode = mode;
    priorFocus = document.activeElement;
    const checkbox = dialog.querySelector('[data-grifo-checkbox]');
    const confirm = dialog.querySelector('[data-grifo-confirm]');
    if (checkbox) checkbox.checked = false;
    if (confirm) { confirm.disabled = true; confirm.textContent = mode === 'checkout' ? 'Confermo e pago' : 'Confermo'; }
    dialog.querySelector('[data-grifo-error]')?.remove();
    dialog.hidden = false;
    document.body.classList.add('grifo-preorder-open');
    dialog.querySelector('.grifo-preorder-dialog')?.focus();
    return true;
  }
  // Capture all product form submits, including Enter and regular add-to-cart.
  // Only the single submit explicitly approved by THIS modal can pass.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !dialogFor(form)) return;
    if (form.dataset.grifoApproval === 'yes') {
      delete form.dataset.grifoApproval;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    open(form, 'cart');
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-grifo-checkbox]')) return;
    const dialog = event.target.closest('[data-grifo-dialog]');
    const confirm = dialog?.querySelector('[data-grifo-confirm]');
    if (confirm) confirm.disabled = !event.target.checked;
  });

  document.addEventListener('click', async (event) => {
    const pay = event.target.closest('[data-grifo-other-payments]');
    if (pay) {
      event.preventDefault();
      if (!pay.disabled) open(pay.closest('form'), 'checkout');
      return;
    }
    const cancel = event.target.closest('[data-grifo-cancel]');
    if (cancel) { close(cancel.closest('[data-grifo-dialog]')); return; }
    const confirm = event.target.closest('[data-grifo-confirm]');
    if (confirm) {
      event.preventDefault();
      if (confirm.disabled) return;
      const dialog = confirm.closest('[data-grifo-dialog]');
      if (!pendingForm || !dialog?.querySelector('[data-grifo-checkbox]')?.checked) return;
      const form = pendingForm;
      const mode = pendingMode;
      const acceptance = form.querySelector('[data-grifone-acceptance]');
      if (acceptance) acceptance.disabled = false;
      if (mode === 'cart') {
        // The approval is consumed by this one event. Next submission opens the modal again.
        form.dataset.grifoApproval = 'yes';
        close(dialog);
        try { form.requestSubmit(); } finally {
          delete form.dataset.grifoApproval;
          // Allow the original Dawn handler to read the input, then reset it.
          queueMicrotask(() => { if (acceptance) acceptance.disabled = true; });
        }
      } else {
        confirm.disabled = true;
        confirm.textContent = 'Aggiunta…';
        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Impossibile aggiungere il prodotto');
          window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
        } catch (error) {
          confirm.textContent = 'Confermo e pago';
          confirm.disabled = false;
          let message = dialog.querySelector('[data-grifo-error]');
          if (!message) {
            message = document.createElement('p');
            message.className = 'grifo-preorder-error';
            message.dataset.grifoError = '';
            message.setAttribute('role','alert');
            dialog.querySelector('.grifo-preorder-actions').before(message);
          }
          message.textContent = error.message || 'Errore durante l’aggiunta al carrello';
        } finally {
          if (acceptance) acceptance.disabled = true;
        }
      }
      return;
    }
    if (event.target.matches('[data-grifo-dialog]')) close(event.target);
  });
  document.addEventListener('keydown', event => {
    const dialog = document.querySelector('[data-grifo-dialog]:not([hidden])');
    if (!dialog) return;
    if (event.key === 'Escape') { event.preventDefault(); close(dialog); }
  });
})();
